import {MultiSelect} from '@mantine/core'
import {SelectItem} from '@mantine/core/lib/components/Select/types'
import React from 'react'
import {useDataTableRefsContext} from '../context'

interface GlobalMultiSelectProps extends React.ComponentPropsWithRef<typeof MultiSelect> {
  selected: Array<string>,
  data: Array<SelectItem>,
  onChange: (ids: Array<string>) => void,
}

export function GlobalMultiSelect({
  selected,
  data,
  onChange,
  ...props
}: GlobalMultiSelectProps) {
  const {pagination} = useDataTableRefsContext().callbacksRef.current

  return (
    <MultiSelect
      className='w-[300px]'
      value={selected}
      data={data}
      onChange={ids => {
        onChange(ids)
        pagination.onSetPage(0)
      }}
      searchable
      limit={30}
      clearable
      sx={() => ({ label: { marginBottom: '1px' }})}
      {...props}
    />
  )
}
